import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  template: `
    <h2 mat-dialog-title>Profit & Loss Report</h2>
    <mat-dialog-content>
      <!-- ส่ง projectCode ให้ component ด้านใน -->
      <app-profit-loss-report [projectCode]="data.projectCode"></app-profit-loss-report>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `
})
export class ProfitLossReportDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ProfitLossReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { projectCode: string }
  ) {
    console.log('dialog data', this.data.projectCode);
  }
}
